<script setup lang="ts">
import { registerSchema, type RegisterForm } from '#shared/utils/validation'

definePageMeta({ layout: 'default' })

useSeoMeta({ title: 'Criar Conta — Descontito', robots: 'noindex' })

const { user, register, loading } = useAuth()
const toast = useToast()

if (user.value) await navigateTo('/')

const form = reactive<RegisterForm>({ name: '', email: '', password: '' })

async function handleRegister() {
  const result = registerSchema.safeParse(form)
  if (!result.success) {
    toast.add({ title: 'Dados inválidos', description: result.error.errors[0]?.message, color: 'error' })
    return
  }
  try {
    await register(form)
    toast.add({ title: 'Conta criada com sucesso!', color: 'success' })
  }
  catch (err: unknown) {
    const message = (err as { data?: { message?: string } })?.data?.message ?? 'Erro ao criar conta'
    toast.add({ title: 'Erro', description: message, color: 'error' })
  }
}
</script>

<template>
  <div class="max-w-md mx-auto py-8">
    <UCard>
      <template #header>
        <div class="text-center">
          <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Criar conta no Descontito</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Já tem conta?
            <NuxtLink to="/login" class="text-primary-500 hover:underline">Entrar</NuxtLink>
          </p>
        </div>
      </template>

      <div class="space-y-4">
        <UFormField label="Nome" name="name">
          <UInput v-model="form.name" placeholder="Seu nome" class="w-full" />
        </UFormField>

        <UFormField label="E-mail" name="email">
          <UInput v-model="form.email" type="email" placeholder="seu@email.com" class="w-full" />
        </UFormField>

        <UFormField label="Senha" name="password">
          <UInput v-model="form.password" type="password" placeholder="Mínimo 8 caracteres" class="w-full" />
        </UFormField>

        <UButton
          color="primary"
          class="w-full"
          :loading="loading"
          @click="handleRegister"
        >
          Criar conta grátis
        </UButton>

        <p class="text-xs text-center text-gray-400">
          Ao criar uma conta, você concorda com nossos Termos de Uso e Política de Privacidade.
        </p>
      </div>
    </UCard>
  </div>
</template>
